import { render, staticRenderFns } from "./InventoryDetailView.vue?vue&type=template&id=6b30bd55&scoped=true"
import script from "./InventoryDetailView.vue?vue&type=script&lang=js"
export * from "./InventoryDetailView.vue?vue&type=script&lang=js"
import style0 from "./InventoryDetailView.vue?vue&type=style&index=0&id=6b30bd55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b30bd55",
  null
  
)

export default component.exports